export interface LoadingViewProps {
  /** The localized "Loading..." text */
  loadingLabel: string;
}

/**
 * Renders a loading indicator while user information is being fetched.
 *
 * Uses semantic ARIA attributes (role="status", aria-live="polite") so that
 * assistive technologies announce the loading state without interrupting
 * the user's current interaction.
 */
export function LoadingView({ loadingLabel }: Readonly<LoadingViewProps>) {
  return (
    <div role="status" aria-live="polite" style={{ padding: 'var(--vai-spacing-m)' }}>
      <span>{loadingLabel}</span>
    </div>
  );
}
